import { useState } from "react";
import CreateNewItem from "../api/CreateNewItem";
import UploadImage from "../api/UploadImage";
import AlertComponent from "../../../components/AlertComponent";
import ErrorAlert from "../../../components/ErrorAlert";

const ItemExpandAdding = ({ child }) => {
  const [itemName, setItemName] = useState("");
  const [itemUsdPrice, setItemUsdPrice] = useState(0);
  const [itemIraqiPrice, setItemIraqiPrice] = useState(0);
  const [itemMoreSales, setItemMoreSales] = useState(false);
  const [itemDesc, setItemDesc] = useState("");
  const [image, setImage] = useState(null);
  const [errorAlert, setErrorAlert] = useState(false);
  const [addAlert, setAddAlert] = useState(false);
  // Handle Adding Item Submit
  const handleAddingItem = async (e) => {
    e.preventDefault();
    let newItem = {
      parentId: `${child.id}`,
      name: itemName,
      ename: itemName,
      country: null,
      image: null,
      status: 1,
      usdprice: itemUsdPrice,
      iraqiPrice: itemIraqiPrice,
      description: itemDesc,
      moresales: itemMoreSales ? 1 : 2,
    };
    let dataId = await CreateNewItem(newItem);
    console.log(dataId);
    // after that updload image
    if (dataId) {
      let dataImage = await UploadImage({
        dataId: dataId,
        imageFile: image,
      });
      if (dataImage) {
        setErrorAlert(false);
        setAddAlert(true);
      } else {
        setErrorAlert(true);
        setAddAlert(false);
      }
    } else {
      setErrorAlert(true);
      setAddAlert(false);
    }
  };
  return (
    <>
      <tr className="border ">
        <td colSpan="7" className="p-2">
          <div className="flex flex-col items-end">
            <h2 className="title-font mb-4 font-medium text-gray-900 py-4 m-4 underline">
              {` إضافة منتج لفئة${child.name}`}
            </h2>
            {errorAlert ? (
              <ErrorAlert
                title={"فشل في عملية إضافة منتج جديد"}
                content={"حدث خطا في عملية إضافة منتج جديد"}
              />
            ) : (
              ""
            )}

            {addAlert ? (
              <AlertComponent
                title={" تمت إضافة منتج جديد بنجاح"}
                content={`تمت إضافة منتج جديد بإسم  ${itemName}  بنجاح`}
              />
            ) : (
              ""
            )}
            <form className="w-full" onSubmit={handleAddingItem}>
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="text-sm leading-7 text-gray-600">الإسم</label>
                <input
                  type="text"
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                  dir="rtl"
                  required={true}
                  className="w-full rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="text-sm leading-7 text-gray-600">السعر العراقي</label>
                <input
                  type="number"
                  min="0"
                  value={itemIraqiPrice}
                  onChange={(e) => setItemIraqiPrice(e.target.value)}
                  dir="rtl"
                  required={false}
                  className="w-full text-right rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="text-sm leading-7 text-gray-600">السعر بالدولار</label>
                <input
                  type="number"
                  min="0"
                  value={itemUsdPrice}
                  onChange={(e) => setItemUsdPrice(e.target.value)}
                  dir="rtl"
                  required={false}
                  className="w-full text-right rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>

              <div className="relative mb-4 flex w-full flex-row-reverse items-end">
                <label className="relative inline-flex items-center cursor-pointer">
                  جعل المنتج الإكثر طلباً
                </label>

                <input
                  type="checkbox"
                  name="moresale"
                  value={itemMoreSales}
                  onChange={(e) => setItemMoreSales(e.target.checked)}
                  className="mx-4 py-4 px-2 rounded border border-gray-300 bg-white text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="text-sm leading-7 text-gray-600">صورة المنتج</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])}
                  dir="rtl"
                  required={true}
                  className="w-full text-right rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
                />
              </div>
              <div className="relative mb-4 flex w-full flex-col items-end">
                <label className="leading-7 text-sm text-gray-600">وصف المنتج</label>
                <textarea
                  value={itemDesc}
                  onChange={(e) => setItemDesc(e.target.value)}
                  dir="rtl"
                  required={false}
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                ></textarea>
              </div>
              <button
                type="submit"
                className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
              >
                إضاقة منتج
              </button>
            </form>
          </div>
        </td>
      </tr>
    </>
  );
};

export default ItemExpandAdding;
